export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_RESET = 'CART_RESET';
export const CART_DISCOUNT_RESET = 'CART_DISCOUNT_RESET';
export const CART_UPDATE_DELIVERY_CHARGES = 'CART_UPDATE_DELIVERY_CHARGES';
